import React from 'react';
import { length } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import Loader from 'sharedComponents/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';

import LoanOfficerCard from './components/LoanOfficerCard';
import useStyles from './useStyles';

const LoanOfficersList = props => {
  const { loanOfficers, isLoading, meta, onLoadMore } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={classes.loaderBox}>
        <Loader />
      </div>
    );
  }

  if (isBlank(loanOfficers)) {
    return (
      <div className={classes.container}>
        <Typography className={classes.emptyLabel} variant="subtitle1">
          {t('components.AdminDashboard.LoanOfficersList.noLoanOfficers')}
        </Typography>
      </div>
    );
  }

  const { totalPages, currentPage } = meta;
  const hasMore = currentPage < totalPages;
  const nextPage = currentPage + 1;

  const handleLoadMore = () => {
    onLoadMore({ page: nextPage });
  };

  return (
    <div className={classes.container} id="scrollableDiv" key="scrollableDiv">
      <InfiniteScroll
        dataLength={length(loanOfficers)}
        next={handleLoadMore}
        hasMore={hasMore}
        loader={
          <div>
            {[1, 2, 3].map(key => (
              <Skeleton key={key} variant="rect" className={classes.skeleton} />
            ))}
          </div>
        }
        scrollableTarget="scrollableDiv"
      >
        {loanOfficers.map(({ id, attributes }) => (
          <LoanOfficerCard key={id} loanOfficer={attributes} />
        ))}
      </InfiniteScroll>
    </div>
  );
};

LoanOfficersList.propTypes = {
  loanOfficers: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  meta: PropTypes.shape(),
};

LoanOfficersList.defaultProps = {
  loanOfficers: [],
  meta: {},
};

export default LoanOfficersList;



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/components/LoanOfficersList/LoanOfficersList.js